import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Box, Button, Collapse, IconButton, List, ListItem, Paper, Slide, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { VerificationProcessService } from '../../../../Component/Api/VerificationAgency/VerificationProcess/VerificationProcessService';
import { VerificationProcess } from '../../../../Component/Model/Dto/VerificationAgency/VerificationProcessTracker';
import { VaProcessReminderState } from '../../../../Component/Model/Enum/BEE123Enums';
import { getDateAsString, getDaysUntilActivity } from '../../../../Helpers/DateFormatter';
import { isNullOrEmpty } from '../../../../Component/Model/helpers';

interface IProps {
    scorecardId: string;
}

export const Reminders = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);
    const [isMounted, setIsMounted] = useState(false);
    const [reminders, setReminders] = useState<VerificationProcess.VerificationProcessReminderDto[]>([]);
    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    const fetchData = async () => {
        setIsMounted(false);
        try {
            const response = await VerificationProcessService.GetScorecardVerificationProcessReminders(props.scorecardId);
            setReminders(response.data);
        }
        catch {
        } finally {
            setIsMounted(true);
            const timeoutId = setTimeout(() => {
                setExpanded(false);
            }, 2000);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }

    const handleRemindMeLater = async (item: VerificationProcess.VerificationProcessReminderDto) => {
        item.reminderState = VaProcessReminderState.RemindMeLater;
        item.dateSaved = new Date();
        try {
            VerificationProcessService.CreateVerificationProcessReminder(item);
            setReminders((prevReminders) =>
                prevReminders.filter((reminder) => reminder !== item)
            );
        } catch (error: any) {
            console.log(error);
        }
    };

    const handleDismiss = async (item: VerificationProcess.VerificationProcessReminderDto) => {
        item.reminderState = VaProcessReminderState.Dismissed;
        item.dateSaved = new Date();
        try {
            VerificationProcessService.CreateVerificationProcessReminder(item);
            setReminders((prevReminders) =>
                prevReminders.filter((reminder) => reminder !== item)
            );
        } catch (error: any) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (!isNullOrEmpty(props.scorecardId)) {
            fetchData();
        }

    }, [props.scorecardId]);


    if (!isMounted) {
        return null;
    }
    return (
        <>
            {reminders.length > 0 &&
                <Slide direction="left" in={isMounted} mountOnEnter timeout={{ enter: 800 }}>
                    <Paper
                        sx={{
                            zIndex: 998,
                            position: 'fixed',
                            bottom: '40px',
                            right: '20px',
                            width: '400px',
                        }}
                    >
                        <Collapse in={expanded}>
                            <List sx={{ maxHeight: '600px', overflowY: 'auto' }}>
                                {reminders.map((item, index) => (
                                    <ListItem key={index} sx={{ padding: 1, borderBottom: 1, borderColor: 'divider' }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                            <Box>
                                                <Typography variant='body2' style={{ fontSize: '0.875rem' }}>
                                                    The following activity is scheduled for <b>{getDaysUntilActivity(item.daysUntilScheduled)}</b>
                                                    {item.daysUntilScheduled >= 1 ? " from now on" : null}
                                                    {item.daysUntilScheduled > 0 && (
                                                        <>
                                                            <br />
                                                            {getDateAsString(item.scheduledDate)}:
                                                        </>
                                                    )}
                                                    <ul style={{ paddingLeft: '20px', marginBottom: '0', listStyleType: 'disc' }}>
                                                        <li>
                                                            <b>{item.vaProcessTypeDescription}</b>
                                                        </li>
                                                    </ul>
                                                </Typography>

                                            </Box>

                                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 , mt: 2}}>
                                                <Button color='primary' size="small" variant="contained" onClick={() => handleRemindMeLater(item)}>
                                                    Remind Me Later
                                                </Button>
                                                <Button color="secondary" size="small" variant="contained" onClick={() => handleDismiss(item)}>
                                                    Dismiss
                                                </Button>
                                            </Box>
                                        </Box>
                                    </ListItem>
                                ))}
                            </List>
                        </Collapse>
                        <Box sx={{ padding: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconButton color="secondary" aria-label="reminders">
                                    <Badge badgeContent={reminders.length} color="primary">
                                        <NotificationsIcon />
                                    </Badge>
                                </IconButton>
                                <Typography sx={{ alignItems: 'center', marginLeft: 0.5 }}>
                                    Reminders
                                </Typography>
                            </Box>
                            <IconButton color="secondary" onClick={toggleExpanded}>
                                {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </Box>
                    </Paper>
                </Slide>
            }
        </>
    );
};
